import { displayFlexRowStyles } from '@app/theme/commonStyles';
import { css } from '@emotion/react';
export const AmountRowStyles = () => [
  displayFlexRowStyles,
  css({
    padding: '10px 20px',
    width: '100%',
    gap: 10,
  }),
];
